import { helpers } from '@vuelidate/validators'

export default other =>
  helpers.withParams({ type: 'equals', other }, value => !helpers.req(value) || value == other) // TODO == or === ?
